import React, { useState, useEffect } from "react";
import logo from "../images/logo2.png";
import * as Cts from "../nexus/constants.js";
import appStyles from "../styles/app.module.css";
import { EventType } from "@azure/msal-browser";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { MsalAuthenticationTemplate } from "@azure/msal-react";
import { AuthenticatedTemplate } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { getHighestRole, generateToken } from "../nexus/nexus.js";
import NavBar from "./NavBar.js";
import { useDispatch } from "react-redux";
import { setValue, setUserRole, setUserToken } from "../store/store";
import { ThreeDots } from "react-loader-spinner";
import { Logout, AccountCircleOutlined } from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import { Modal, Box, Button, Typography, IconButton } from "@mui/material";
import { BrowserUtils } from "@azure/msal-browser";
const jwt = require("jsonwebtoken");
const ErrorComponent = (error) => {
  return <p>An Error Occurred: {error}</p>;
};

const LoadingComponent = () => {
  return (
    <div className={appStyles.introContainer}>
      <div className={appStyles.introText}>
        <ThreeDots color="#186d90" height={250} width={250} />
      </div>
    </div>
  );
};
export default function App() {
  const [photo, setPhoto] = useState(null);
  const [userName, setUserName] = useState(null);
  const [role, setRole] = useState(null);
  const dispatch = useDispatch();
  const { instance, accounts } = useMsal();
  const [open, setOpen] = useState(true);

  const AUTO_LOGOUT_TIME = 8 * 60 * 60 * 1000;
  const isAuthenticated = useIsAuthenticated();
  instance.addEventCallback((event) => {
    if (
      event.eventType === EventType.LOGIN_SUCCESS ||
      event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS
    ) {
      instance.setActiveAccount(event.payload.account);

      setUserName(event.payload.account.name);
      dispatch(setValue(event.payload.account.name));
      let highestRole = Cts.noAccess;
      if (event.payload.idTokenClaims.roles) {
        highestRole = getHighestRole(event.payload.idTokenClaims.roles);
      }
      setRole(highestRole);
      dispatch(setUserRole(highestRole));
      generateToken(event.payload.account, highestRole);
      getUserPhoto(event.payload.accessToken);
    }
  });
  const generateToken = async (user, role) => {
    try {
      // Constructing payload for the JWT token
      const tokenPayload = {
        sub: user.homeAccountId, // Subject identifier
        username: user.name, // User's name
        role: role, // User's role
      };

      // Get expiration time for the token
      const expiresIn = Cts.expirationTime;

      // Sign the token using the payload, secret key, and expiration time
      const userToken = jwt.sign(
        tokenPayload,
        process.env.REACT_APP_X_INITIAL, // Secret key
        {
          expiresIn, // Token expiration time
        }
      );

      // Store the generated token in the Redux store
      dispatch(setUserToken(userToken));
    } catch (error) {
      // Log any errors that occur during token generation
      console.error(error.message);
    }
  };
  useEffect(() => {
    if (accounts.length > 0) {
      localStorage.setItem("isLoggedIn", "true");
    }
  }, [accounts]);
  // useEffect(() => {
  //   const checkLoginStatus = () => {
  //     if (localStorage.getItem("isLoggedIn") === "true") {
  //       setOpen(false);
  //     }
  //   };
  //   checkLoginStatus();
  //   const interval = setInterval(checkLoginStatus, 500);

  //   return () => clearInterval(interval);
  // }, []);

  const getUserPhoto = async (accessToken) => {
    const response = await fetch(Cts.photoUrl, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    response.ok
      ? setPhoto(await response.blob())
      : console.log("Error retrieving user photo:", response.status);
  };
  const handleLogout = async () => {
    console.log("Logging out...");
    localStorage.setItem("isLoggedIn", "false");

    try {
      await instance.logoutPopup({
        account: instance.getActiveAccount(),
        onRedirectNavigate: () => !BrowserUtils.isInIframe(),
      });
      window.location.href = "/";
      // if (window.opener) {
      //   window.close();
      // } else {
      //   // Redirect main window to root after logout
      //   window.location.href = "/";
      // }
    } catch (error) {
      console.error("Logout error:", error);
    }

    setUserName(null);
    setRole(null);
    dispatch(setValue(null));
    dispatch(setUserRole(null));
    dispatch(setUserToken(null));
    console.log("Logout complete");
  };

  const handleLogin = () => {
    if (window.location.pathname !== "/") {
      window.location.href = "/"; // Redirect to home page
    } else {
      instance.loginRedirect({
        scopes: ["user.read"],
      });
    }
  };

  useEffect(() => {
    const logoutTimer = setTimeout(() => {
      handleLogout();
    }, AUTO_LOGOUT_TIME);

    return () => clearTimeout(logoutTimer); // Cleanup on unmount
  }, []);
  const handleClose = () => setOpen(false);
  const isLoggedIn = localStorage.getItem("isLoggedIn");
  return (
    <>
      <div className={appStyles.header}>
        <div className={appStyles.arrowContainer}>
          <div className={appStyles.arrowText}>
            <h1>
              LEVEL
              <br />
              CROSSING
              <br />
              REMOVAL
            </h1>
            <p>PROJECT</p>
          </div>
          <span className="arrow"></span>
        </div>

        <div className={appStyles.headerText}>
          <h3 className={appStyles.headerLine}>
            LXRP Management Dashboard Tool
          </h3>
          <p className={appStyles.protected}>PROTECTED</p>
        </div>

        {(isLoggedIn === null && !userName) || isLoggedIn !== "true" ? (
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="login-modal"
            aria-describedby="login-modal-description"
          >
            <Box className={appStyles.modalContainer}>
              <div className={appStyles.modalContent}>
                <div className={appStyles.imageContainer}>
                  <img src={logo} className={appStyles.image} />
                </div>
                <div className={appStyles.iconContainer}>
                  <AccountCircleOutlined
                    fontSize="large"
                    className={appStyles.icon}
                  />
                </div>

                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleLogin}
                  className={appStyles.loginButton}
                >
                  Log in
                </Button>
              </div>
            </Box>
          </Modal>
        ) : (
          <>
            <MsalAuthenticationTemplate
              interactionType={InteractionType.Redirect}
              errorComponent={ErrorComponent}
              loadingComponent={LoadingComponent}
            >
              {userName && (
                <div className={appStyles.profile}>
                  <AuthenticatedTemplate>
                    <div className={appStyles.profileContainer}>
                      <div className={appStyles.profileCard}>
                        <div className={appStyles.userInfo}>
                          <div className={appStyles.userName}>
                            {userName} -{" "}
                            <span className={appStyles.userRole}>{role}</span>
                          </div>
                          {photo && (
                            <img
                              className={appStyles.userPhoto}
                              src={URL.createObjectURL(photo)}
                              alt="Your Photo"
                            />
                          )}
                        </div>
                      </div>
                      <Tooltip title="Log out">
                        <Logout
                          className={appStyles.logoutIcon}
                          onClick={handleLogout}
                        />
                      </Tooltip>
                    </div>
                  </AuthenticatedTemplate>
                </div>
              )}
            </MsalAuthenticationTemplate>
          </>
        )}
      </div>

      {role !== Cts.noAccess && (
        <div className={appStyles.leftNavBar}>
          <NavBar />
        </div>
      )}
    </>
  );
}
